//utility function
function hasParentWithMatchingSelector(target, selector) {
  return [...document.querySelectorAll(selector)].some(el =>
    el !== target && el.contains(target)
  )
}

function toggleAccordion(e) {
  //verify that this has a parent element with the class "accordion"
  // and that this is a "button"
  if( e.target.nodeName == "BUTTON" && hasParentWithMatchingSelector(e.target, ".accordion") ) {
    var etp = e.target.parentElement;
    var opendiv = e.target.nextElementSibling;

    if( etp.classList.contains("expanded") ) {
      //close this accordion, since it's open and was clicked
      etp.classList.remove("expanded");
      opendiv.style.maxHeight = null;
    }
    else {
      //close all open accordions
      Array.from( e.target.closest(".accordion").children ).forEach(
        function(outerdiv) {
          var odd = outerdiv.querySelector("div");
          if(odd == null) return;
          odd.style.maxHeight = null;
          outerdiv.classList.remove("expanded");
        }
      );

      //then, open this accordion
      etp.classList.add("expanded");
      opendiv.style.maxHeight = opendiv.scrollHeight + "px";
    }
  }
}

function fixAccordionScrollHeight(e) {
  //find all expanded divs
  var opendivs = Array.from( document.querySelectorAll(".expanded div") );

  //for each one, reset the .style.maxHeight to be .scrollHeight px
  opendivs.forEach( function(a) { a.style.maxHeight = a.scrollHeight + "px"; } );
}

document.addEventListener("click", toggleAccordion);
window.addEventListener("resize", fixAccordionScrollHeight);
